module.exports = __webpack_public_path__ + "img/payment-systems.a2cb93ab.png";